export const convertToDays = (hours: number): number => {
  return Math.round((hours * 10) / 8) / 10
}
